import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'
import { Link } from 'react-router'

import * as styles from './styles'

const RugCardHeader = ({ fromPage, rug }) => (
  <Card.Content>
    <Card.Meta>{rug.id}</Card.Meta>

    <Link to={{ pathname: `/rug/${rug.id}`, query: { fromPage } }}>
      <Card.Header as="h3" style={styles.link}>
        {rug.name}
      </Card.Header>
    </Link>
  </Card.Content>
)

RugCardHeader.propTypes = {
  fromPage: PropTypes.string.isRequired,
  rug: PropTypes.object.isRequired,
}

export default RugCardHeader
